// extracted by mini-css-extract-plugin
module.exports = {"container":"Pieces-module--container--15PBo","list":"Pieces-module--list--3bR4W","subtitle":"Pieces-module--subtitle--3I2p_"};